<template>
  <div class="no-data-available content-centered text-muted"
       :style="{'min-height': `${height}em`}">
    {{ message ? message : $t('No Data Available') }}
  </div>
</template>

<script>
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: 'NoDataAvailable',
    props: {
      height: {
        type: [Number, String],
        default: 1
      },
      message: {
        type: String,
        default: null
      }
    }
  };
</script>

<style lang="scss">
</style>
